/* BetterWithClara · Journal: reading progress line, "In this article" contents, copy-link button. No dependencies. */
(function () {
  var prose = document.querySelector('.bj-prose');
  var article = document.querySelector('.bj-article');

  if (prose) {
    var only = function (el, tag) {
      var k = el.children; return k.length === 1 && k[0].tagName === tag && el.textContent.trim() === k[0].textContent.trim();
    };
    /* Short standalone lines in bold read as story beats. */
    prose.querySelectorAll(':scope > p').forEach(function (el) {
      if (only(el, 'STRONG') && el.textContent.trim().length <= 140) el.classList.add('bj-beat');
    });
    /* An image on its own line becomes an editorial image; a following line in italics becomes its caption. */
    prose.querySelectorAll(':scope > p, :scope > div').forEach(function (el) {
      var k = el.children;
      if (k.length === 1 && k[0].tagName === 'IMG' && el.textContent.trim() === '') {
        el.classList.add('bj-fig');
        var n = el.nextElementSibling;
        if (n && n.tagName === 'P' && only(n, 'EM')) n.classList.add('bj-cap');
      }
    });
  }

  /* Contents list built from the article's H2 headings (the "In short" box is skipped). */
  if (prose) {
    var heads = [].slice.call(prose.querySelectorAll('h2')).filter(function (h) { return !h.closest('.bj-inshort'); });
    if (heads.length >= 2) {
      var used = {};
      var items = heads.map(function (h) {
        if (!h.id) {
          var base = h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
          var id = base, n = 2; while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
          h.id = id;
        }
        used[h.id] = true;
        return '<li><a href="#' + h.id + '">' + h.textContent.trim().replace(/</g, '&lt;') + '</a></li>';
      }).join('');
      document.querySelectorAll('[data-bj-toc]').forEach(function (ol) { ol.innerHTML = items; });
      var inline = document.querySelector('.bj-toc');
      if (inline) {
        var sum = inline.querySelector('summary');
        if (sum) sum.insertAdjacentHTML('beforeend', '<span class="bj-toc-n">' + heads.length + ' sections</span>');
        inline.hidden = false;
        inline.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { inline.open = false; }); });
      }
      var side = document.querySelector('.bj-toc-side'); if (side) side.classList.add('is-ready');
    }
  }

  /* Reading progress line. */
  var bar = document.querySelector('.bj-progress');
  if (bar && article) {
    var tick = false;
    var update = function () {
      var r = article.getBoundingClientRect(), total = r.height - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      bar.style.width = (p * 100) + '%'; tick = false;
    };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Optional phone bar: shows after a third of the article, hides once the final workbook box is near. */
  var stick = document.querySelector('[data-bj-sticky]');
  if (stick && prose) {
    var fin = document.querySelector('[data-bj-final]'), sTick = false;
    var sUpdate = function () {
      var r = prose.getBoundingClientRect(), vh = window.innerHeight;
      var past = -r.top > r.height * 0.33;
      var near = fin ? fin.getBoundingClientRect().top < vh * 1.15 : r.bottom < vh;
      var on = past && !near;
      stick.classList.toggle('is-on', on);
      stick.setAttribute('aria-hidden', on ? 'false' : 'true');
      var l = stick.querySelector('a'); if (l) l.tabIndex = on ? 0 : -1;
      sTick = false;
    };
    window.addEventListener('scroll', function () { if (!sTick) { sTick = true; requestAnimationFrame(sUpdate); } }, { passive: true });
    sUpdate();
  }

  /* Copy link. */
  document.querySelectorAll('[data-bj-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var label = b.querySelector('.bj-t');
      var done = function (ok) {
        if (!label) return; var o = label.getAttribute('data-l') || label.textContent; label.setAttribute('data-l', o);
        label.textContent = ok ? 'Link copied' : 'Copy failed'; setTimeout(function () { label.textContent = o; }, 1800);
      };
      try { navigator.clipboard.writeText(b.getAttribute('data-bj-copy')).then(function () { done(true); }, function () { done(false); }); }
      catch (e) { done(false); }
    });
  });
})();
